// extracted by mini-css-extract-plugin
export var CoverWrapper = "Cover-module--CoverWrapper--2tdrx";
export var CoverUpperText = "Cover-module--CoverUpperText--nV4tE";
export var CoverGallery = "Cover-module--CoverGallery--Rd9Ys";
export var CoverGalleryImg = "Cover-module--CoverGalleryImg--RACMO";
export var CoverLowerText = "Cover-module--CoverLowerText--BNbwq";